/**
 * <s-share-button> shares the current article with the device's native share
 * sheet, or copies the link to the clipboard where sharing isn't available.
 * Expects data-share-url, data-share-title and data-copied-message, a <button>
 * child, and a [data-share-status] live region child.
 */
class ShareButton extends HTMLElement {
  #button = null;
  #status = null;
  #resetTimer = 0;

  connectedCallback() {
    this.#button = this.querySelector('button');
    this.#status = this.querySelector('[data-share-status]');
    this.#button?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#handleClick);
    window.clearTimeout(this.#resetTimer);
  }

  #handleClick = async () => {
    const url = this.dataset.shareUrl || window.location.href;
    const title = this.dataset.shareTitle || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      this.#announce(this.dataset.copiedMessage || '');
    } catch (error) {
      window.prompt(this.dataset.copyPrompt || '', url);
    }
  };

  #announce(message) {
    if (!this.#status || !message) return;
    this.#status.textContent = message;
    this.#status.hidden = false;
    window.clearTimeout(this.#resetTimer);
    this.#resetTimer = window.setTimeout(() => {
      this.#status.textContent = '';
      this.#status.hidden = true;
    }, 2500);
  }
}

if (!customElements.get('s-share-button')) customElements.define('s-share-button', ShareButton);
